<template lang="pug">
.custom-pagination
  //- .d-flex.align-items-center
  //-   .text-medium(style='opacity: 0.5')
  //-     | หน้า
  //-     | {{ current }}
  //-     | จาก
  //-     | {{ total }}

  .d-flex.align-items-center.justify-content-between
    //- template(v-if='!compact')
    button.btn.btn-sm.btn-outline-primary(
      @click='current -= 1'
      :disabled='current <= 1'
      :class='{ "px-3": !compact }'
    )
      .d-flex.align-items-center
        i.fa.fa-angle-left(style='font-size: 17px')
        //- template(v-if='!compact')
        | ก่อนหน้า

    nav.mx-3
      ul.pagination.m-0(
        :class='{ "pagination-sm": this.compact }'
      )
        template(v-if='shouldDisplayPrevButton')
          li.page-item
            a.page-link(@click='current = 1' href='#')
              | 1

          //- insert v-if here to prevent idiotic display glitch
          template(v-if='total !== MAX_VISIBLE_PAGES + 1')
            li.page-item()
              a.page-link(
                style='letter-spacing: 2'
                @click='current = firstVisiblePage'
              )
                | ...

        template(v-for='i in visiblePageCount')
          li.page-item(
            :class="(firstVisiblePage + i) === current ? `active`:``"
          )
            a.page-link(@click='current = firstVisiblePage + i' href='#')
              | {{ i + firstVisiblePage }}

        template(v-if='shouldDisplayNextButton')
          //- insert v-if here to prevent idiotic display glitch
          template(v-if='total !== firstVisiblePage + visiblePageCount + 1')
            li.page-item
              a.page-link(
                style='letter-spacing: 2'
                @click='current = firstVisiblePage + visiblePageCount + 1'
              )
                | ...
          li.page-item
            a.page-link(@click='current = total' href='#')
              //- | {{ firstVisiblePage + visiblePageCount }}
              | {{ total }}

    //- template(v-if='!compact')
    button.btn.btn-sm.btn-outline-primary(
      @click='current += 1'
      :disabled='current >= total'
      :class='{ "px-3": !compact }'
    )
      .d-flex.align-items-center
        //- template(v-if='!compact')
        | ถัดไป
        i.fa.fa-angle-right(style='font-size: 17px')

</template>

<script>
// const MAX_VISIBLE_PAGES = 5;

export default {
  props: {
    total: {
      default: 3,
    },

    value: {},
    compact: {
      default: false,
    },
  },

  data: () => ({
    current: 1,
    // MAX_VISIBLE_PAGES,
  }),

  watch: {
    // bind value & current
    current() { this.onCurrentChanged(); },
    value() { this.onValueChanged(); },

  },
  methods: {
    // bind value & current
    onCurrentChanged() { this.$emit('input', this.current); },
    onValueChanged() { this.current = this.value; },

  },

  mounted() {
    // bind value & current
    if (this.value) { this.onValueChanged(); }
  },

  computed: {
    MAX_VISIBLE_PAGES() {
      return !this.compact ? 7 : 3;
    },
    shouldDisplayPrevButton() {
      return this.firstVisiblePage > 0;
    },
    shouldDisplayNextButton() {
      return (this.firstVisiblePage + this.visiblePageCount) < this.total;
    },

    visiblePageCount() {
      if (this.total < this.MAX_VISIBLE_PAGES) {
        return this.total;
      }
      // if (this.current === this.total && (this.total % (this.MAX_VISIBLE_PAGES - 1))) {
      //   return this.MAX_VISIBLE_PAGES + 1;
      // }
      return this.MAX_VISIBLE_PAGES;
    },
    firstVisiblePage() {
      if (this.total > this.MAX_VISIBLE_PAGES) {
        let ratio = this.current / this.MAX_VISIBLE_PAGES;
        const remainder = this.current % this.MAX_VISIBLE_PAGES;
        if (remainder === 0) {
          ratio -= 1;
        }
        const startPage = Math.floor(ratio) * this.MAX_VISIBLE_PAGES;

        if (startPage + this.visiblePageCount >= this.total) {
          return this.total - this.visiblePageCount;
        }
        return startPage;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
.custom-pagination {
  .page-item {
    cursor: pointer;

    // disable text selection by user
    -webkit-user-select: none;  /* Chrome all / Safari all */
    -moz-user-select: none;     /* Firefox all */
    -ms-user-select: none;      /* IE 10+ */
    user-select: none;

    .page-link {
      text-align: center;
      min-width: 48px;
    }
  }

  .page-item {

  }
}
</style>
